import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PROVIDERS } from './all-policy-issuance-providers'


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: PROVIDERS,
})
export class PolicyIssuanceModule {
  static forRoot(): ModuleWithProviders<PolicyIssuanceModule> {
    return {
      ngModule: PolicyIssuanceModule,
      providers: PROVIDERS 
    };
  }

}
